module.exports = __webpack_public_path__ + "img/examples-en-8.0387cbc4.jpg";